/**
 * Helpers para POST /api/register-user-plan (contrato membresías).
 * date_birth: MM-DD-YYYY. message en errores 422 puede ser array o string.
 */

/**
 * Extrae un texto usable para toast/UI desde la respuesta de error del API.
 * @param {Error|Object} err
 * @param {string} [fallback]
 * @returns {string}
 */
export function formatRegisterApiMessage(err, fallback = 'Error al procesar el registro. Intenta de nuevo.') {
  const data = (err && err.response && err.response.data) || err || {}
  const raw = data.message != null ? data.message : data.error
  if (Array.isArray(raw)) {
    return raw.filter(Boolean).join(' ').trim() || fallback
  }
  if (typeof raw === 'string' && raw.trim()) return raw.trim()
  if (raw != null && typeof raw === 'object') {
    try {
      return JSON.stringify(raw)
    } catch (e) {
      return fallback
    }
  }
  return fallback
}

/**
 * ¿El plan requiere edad mínima 60+ (Tu Salud Senior)?
 * @param {Object|null} plan
 * @returns {boolean}
 */
export function isSeniorPlan(plan) {
  if (!plan) return false
  if (plan.catalogId === 'senior' || plan.id === 'senior') return true
  const name = String(plan.name || '').toLowerCase()
  return name.includes('senior')
}

/**
 * Valida fecha de nacimiento en formato MM-DD-YYYY.
 * @param {string} value
 * @returns {boolean}
 */
export function isValidDateBirthMdy(value) {
  if (!value || typeof value !== 'string') return false
  const m = value.trim().match(/^(\d{2})-(\d{2})-(\d{4})$/)
  if (!m) return false
  const month = Number(m[1])
  const day = Number(m[2])
  const year = Number(m[3])
  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return false
  const d = new Date(year, month - 1, day)
  return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day
}

/**
 * Formatea tecleo hacia MM-DD-YYYY (solo dígitos).
 * @param {string} raw
 * @returns {string}
 */
export function maskDateBirthInput(raw) {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`
  return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`
}
